import "../plugins/EasyResponsiveTabs"

export default function initResponsiveTabs() {
    jQuery('.responsiveTabs').each(function() {
        let $responsiveTabs = $(this);
        $responsiveTabs.easyResponsiveTabs({
            type: 'vertical', //Types: default, vertical, accordion           
            width: 'auto', //auto or any custom width
            fit: true,   // 100% fits in a container
        });
    })
}